// extracted by mini-css-extract-plugin
export default {"table":"Flussi_table__rczVn"};